var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-button",class:[_vm.buttonClass, _vm.widthClass]},[_c('b-button',{staticClass:"rounded-pill",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('clicked')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }